import { render, staticRenderFns } from "./OnboardingPresentingRight.vue?vue&type=template&id=2946137f&scoped=true&"
import script from "./OnboardingPresentingRight.vue?vue&type=script&lang=js&"
export * from "./OnboardingPresentingRight.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPresentingRight.vue?vue&type=style&index=0&id=2946137f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946137f",
  null
  
)

export default component.exports